import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { UntypedFormBuilder } from '@angular/forms';
import { ComparerService } from 'src/app/shared/utility/comparer';
import { AuditService } from '../../../../shared/services/audit.service';
import { faHistory, faExternalLink} from '@fortawesome/pro-light-svg-icons';
import { AuditFormComponent } from 'src/app/case/audit-form/audit-form.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-conveyancing-purchase-property-details',
  templateUrl: './conveyancing-purchase-property-details.component.html',
  styleUrls: ['./conveyancing-purchase-property-details.component.scss']
})
export class ConveyancingPurchasePropertyDetailsComponent implements OnInit {

  @Input() caseId: number;

  dataLoaded: boolean = false;
  viewInit = false;
  faHistory = faHistory;
  faExternalLink = faExternalLink;

  propertyDetails = this.fb.group({
    id: [],
    caseId: [],
    purchaseAddressLine1 : [],
    purchaseAddressLine2 : [],
    purchaseAddressLine3 : [],
    purchaseAddressLine4 : [],
    purchaseAddressLine5 : [],
    purchasePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    agreedPurchasePrice : [],
    sellerSolicitorName : [],
    sellerSolicitorEmailAddress : [],
    sellerSolicitorContactNumber : [],
    seller1Name : [],
    seller2Name : [],
    sellerSolicitorAddressLine1 : [],
    sellerSolicitorAddressLine2 : [],
    sellerSolicitorAddressLine3 : [],
    sellerSolicitorAddressLine4 : [],
    sellerSolicitorAddressLine5 : [],
    sellerSolicitorPostcode : [],
    sellerSolicitorReference : [],
    titleGuaranteeType: [],
    chattels: [],
    stampDuty : []
  }, { });

  initialDetails = this.fb.group({
    id: [],
    caseId: [],
    purchaseAddressLine1 : [],
    purchaseAddressLine2 : [],
    purchaseAddressLine3 : [],
    purchaseAddressLine4 : [],
    purchaseAddressLine5 : [],
    purchasePostcode : [],
    propertyIsUnregistered : [],
    titleNumber : [],
    propertyType : [],
    landlordName : [],
    landlordAddressLine1 : [],
    landlordAddressLine2 : [],
    landlordAddressLine3 : [],
    landlordAddressLine4 : [],
    landlordAddressLine5 : [],
    landlordPostcode : [],
    managementCompanyName : [],
    managementCompanyAddressLine1 : [],
    managementCompanyAddressLine2 : [],
    managementCompanyAddressLine3 : [],
    managementCompanyAddressLine4 : [],
    managementCompanyAddressLine5 : [],
    managementCompanyPostcode : [],
    solarPanelsPresent : [],
    solarPanelsOwnedOutright  : [],
    solarPanelsCompany  : [],
    solarPanelsOwnerAddressLine1 : [],
    solarPanelsOwnerAddressLine2 : [],
    solarPanelsOwnerAddressLine3 : [],
    solarPanelsOwnerAddressLine4 : [],
    solarPanelsOwnerAddressLine5 : [],
    solarPanelsOwnerPostcode : [],
    hasSepticTank : [],
    agreedPurchasePrice : [],
    sellerSolicitorName : [],
    sellerSolicitorEmailAddress : [],
    sellerSolicitorContactNumber : [],
    seller1Name : [],
    seller2Name : [],
    sellerSolicitorAddressLine1 : [],
    sellerSolicitorAddressLine2 : [],
    sellerSolicitorAddressLine3 : [],
    sellerSolicitorAddressLine4 : [],
    sellerSolicitorAddressLine5 : [],
    sellerSolicitorPostcode : [],
    sellerSolicitorReference : [],
    titleGuaranteeType: [],
    chattels: [],
    stampDuty : []
  }, { });

  constructor(
        private caseService: CaseService,
        private fb: UntypedFormBuilder,
        public activeModal: NgbActiveModal,
        private comp: ComparerService,
        private auditService: AuditService,
        private modalService: ModalService) {

          

        }

  ngOnInit(): void {
      this.caseService.getConveyancingPurchasePropertyDetails(this.caseId).subscribe((response : any) => {

        this.propertyDetails.patchValue(response.propertyDetails);
        this.initialDetails.patchValue(response.propertyDetails);
        this.dataLoaded = true;
      });
  }

  updateField(){

    this.caseService.updateConveyancingPurchasePropertyDetails(this.propertyDetails.value).subscribe((response : any) => {

    }, (error : any) => {


    });
  }

  close(){

    if(this.comp.objectsDifferent(this.initialDetails.value, this.propertyDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'PropertyDetails', this.initialDetails.value, this.propertyDetails.value).subscribe((response : any) => {
        this.activeModal.close(true);
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl'});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "PropertyDetails";

  }
}
